﻿import axios from "axios";
import { LandingPageInfoModel } from "./types/LandingPageInfoModel";
import { FileContentResult } from "./types/FileContentResult";
import { BCSPjmDokumente } from "./types/BCSPjmDokumente";
import { HaendlerModel } from "./types/HaendlerModel";
import { RepStatusEnum } from "./types/RepStatusEnum";
import { ServiceOperationEnum } from "./types/ServiceOperationEnum";
import { correctDates } from "../core/ajax/helper";

declare var _root_url: string;
function mapUrl(url: string) {
    return _root_url + url;
}

export abstract class AjaxController {

  public static async GetReperaturstatus(token: string): Promise<LandingPageInfoModel> {
    const result = await axios.post(mapUrl("Ajax/GetReperaturstatus"), {token});
    return correctDates(result.data);
  }

  public static async GetNewDownloadImage(artikelnummer: string): Promise<FileContentResult> {
    const result = await axios.post(mapUrl("Ajax/GetNewDownloadImage"), {artikelnummer});
    return correctDates(result.data);
  }

  public static async SetKVABedingung(decision: boolean, proposid: number, kva_option: number, Token: string, user_kto: string): Promise<boolean> {
    const result = await axios.post(mapUrl("Ajax/SetKVABedingung"), {decision, proposid, kva_option, Token, user_kto});
    return correctDates(result.data);
  }

  public static async AddComment(ProPosID: number, comment: string, Token: string): Promise<boolean> {
    const result = await axios.post(mapUrl("Ajax/AddComment"), {ProPosID, comment, Token});
    return correctDates(result.data);
  }

  public static async SearchTokenAfterProjektPosAndPLZ(projektposid: string, plz: string): Promise<string> {
    const result = await axios.post(mapUrl("Ajax/SearchTokenAfterProjektPosAndPLZ"), {projektposid, plz});
    return correctDates(result.data);
  }

  public static async GetFilesToProjektPosID(ProjektPosId: number, token: string): Promise<BCSPjmDokumente[]> {
    const result = await axios.post(mapUrl("Ajax/GetFilesToProjektPosID"), {ProjektPosId, token});
    return correctDates(result.data);
  }

  public static async CheckZKDVorkassaForKVARechnung(kto: string, token: string): Promise<boolean> {
    const result = await axios.post(mapUrl("Ajax/CheckZKDVorkassaForKVARechnung"), {kto, token});
    return correctDates(result.data);
  }

  public static async GetHaendler(): Promise<HaendlerModel[]> {
    const result = await axios.post(mapUrl("Ajax/GetHaendler"), {});
    return correctDates(result.data);
  }

  public static async Dummy(): Promise<RepStatusEnum> {
    const result = await axios.post(mapUrl("Ajax/Dummy"), {});
    return correctDates(result.data);
  }

  public static async Dummy1(): Promise<ServiceOperationEnum> {
    const result = await axios.post(mapUrl("Ajax/Dummy1"), {});
    return correctDates(result.data);
  }

}
